const DEFAULT_PAGE_SIZE = 100;
const DEFAULT_MAX_ROWS = 2000;

export const fetchAllPages = async (
  queryFactory,
  { pageSize = DEFAULT_PAGE_SIZE, maxRows = DEFAULT_MAX_ROWS, label = 'Datensätze' } = {},
) => {
  const safePageSize = Math.max(1, Math.min(Number(pageSize) || DEFAULT_PAGE_SIZE, 500));
  const safeMaxRows = Math.max(safePageSize, Math.min(Number(maxRows) || DEFAULT_MAX_ROWS, 10_000));
  const rows = [];

  for (let offset = 0; offset < safeMaxRows; offset += safePageSize) {
    const upper = Math.min(offset + safePageSize - 1, safeMaxRows - 1);
    const { data, error } = await queryFactory().range(offset, upper);
    if (error) throw error;

    const page = Array.isArray(data) ? data : [];
    rows.push(...page);
    if (page.length < safePageSize) return rows;
  }

  console.warn(`${label} wurden bei ${safeMaxRows} Einträgen begrenzt. Für größere Bestände ist eine echte Seitenansicht erforderlich.`);
  return rows;
};

export const fetchPagedTable = async (
  supabase,
  table,
  {
    columns = '*',
    orderBy = 'created_at',
    ascending = false,
    pageSize = DEFAULT_PAGE_SIZE,
    maxRows = DEFAULT_MAX_ROWS,
  } = {},
) => fetchAllPages(
  () => supabase.from(table).select(columns).order(orderBy, { ascending }),
  { pageSize, maxRows, label: table },
);
